export const logicalConditional = (p: boolean, q: boolean): boolean => !p || q;

export const cond = logicalConditional;
